/*
  CDS — Restauration fiable de la position de défilement au retour arrière.

  Problème : au retour arrière (sans bfcache), le navigateur restaure la position
  AVANT que la page ait sa hauteur finale (images en lazy-load, contenu tardif).
  La position demandée est alors écrêtée à la hauteur du moment → on se retrouve
  en haut de la page.

  Solution : on prend la main (scrollRestoration = 'manual'), on mémorise la
  position par URL, et on la restaure en réessayant tant que la page grandit.

  Notes :
  - On n'ajoute AUCUN listener 'beforeunload'/'unload' : ils désactiveraient le bfcache.
  - Si la page revient du bfcache (pageshow.persisted), le navigateur a déjà tout
    restauré : on ne touche à rien.
*/
(function () {
  if (typeof window === 'undefined' || !('sessionStorage' in window)) return;
  if (window.__cdsScrollRestore) return;
  window.__cdsScrollRestore = true;

  var PREFIX = 'cds:scroll:';
  var restoredFromBfcache = false;

  function key() {
    return PREFIX + window.location.pathname + window.location.search;
  }

  function store(y) {
    try {
      if (y > 0) sessionStorage.setItem(key(), String(y));
      else sessionStorage.removeItem(key());
    } catch (e) {}
  }

  function save() {
    store(window.scrollY || window.pageYOffset || 0);
  }

  /* On prend la main sur la restauration native (elle se déclenche trop tôt) */
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  } catch (e) {}

  /* Sauvegarde : 'pagehide' + passage en arrière-plan (compatible bfcache) */
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  /* Retour depuis le bfcache : le navigateur a déjà restauré la page telle quelle */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restoredFromBfcache = true;
  });

  function navType() {
    try {
      var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (entries && entries.length && entries[0].type) return entries[0].type;
      if (performance.navigation) {
        if (performance.navigation.type === 2) return 'back_forward';
        if (performance.navigation.type === 1) return 'reload';
      }
    } catch (e) {}
    return 'navigate';
  }

  function maxScroll() {
    var doc = document.documentElement;
    var h = Math.max(
      document.body ? document.body.scrollHeight : 0,
      doc ? doc.scrollHeight : 0
    );
    return Math.max(0, h - window.innerHeight);
  }

  function restore() {
    if (restoredFromBfcache) return;   /* déjà géré par le navigateur */
    if (window.location.hash) return;  /* ancre : on laisse le navigateur gérer */

    var type = navType();
    if (type !== 'back_forward' && type !== 'reload') return;

    var target = parseInt(sessionStorage.getItem(key()) || '', 10);
    if (!target || target < 1) return;

    var tries = 0;
    var MAX_TRIES = 90; /* ~1,5 s : le temps que les images réservent leur place */

    (function attempt() {
      if (restoredFromBfcache) return;
      var max = maxScroll();

      if (max >= target) {
        window.scrollTo(0, target);
        return; /* la page est assez haute : position exacte atteinte */
      }

      /* Pas encore assez haute : on s'approche au mieux et on réessaie */
      window.scrollTo(0, Math.min(target, max));
      if (++tries < MAX_TRIES) requestAnimationFrame(attempt);
    })();
  }

  if (document.readyState === 'complete') {
    restore();
  } else {
    window.addEventListener('load', restore);
  }
  /* Passe supplémentaire : images/polices arrivées après 'load' */
  window.addEventListener('load', function () { setTimeout(restore, 350); });
})();
